import 'core-js/stable';

async function loadModules() {
    await import(/* webpackMode: "eager" */ './navigation/navigation');
    await import(/* webpackMode: "eager" */ './user_context/user-context');
    await import(/* webpackMode: "eager" */ './saved_configuration/save-configuration');
}

document.addEventListener('DOMContentLoaded', () => {
    loadModules();
});
